export default "__VITE_ASSET__CHXb5iDi__"